export class BscPerspectivePersonEntity{
    id:number;
    perspectiveId:number;
    personId:number;

    constructor(){}
}